import React, { Component, PropTypes } from 'react';
import Header from './HeaderMenu';
import styles from './Index.less';
import { connect } from 'dva';
import { history } from '../../utils/config';
import { fetchPost } from '../../utils/request';
import auth from '../../services/auth';

class Index extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      menus: []
    }
  }

  componentDidMount () {
    this.getData()
  }

  /**
   * 获取业务系统列表
   */
  getData () {
    fetchPost('/business/line',
      this.state.params).then(json => {
        if (json.code == 0) {
          this.setState({
            menus:json.data.list
          })
        }
        else if (json.code == 201) {
          auth.logout();
        }
    })
  }

  goPages (url) {
    let accessToken = localStorage.getItem('accessToken')
    let userName = localStorage.getItem('userName');
    window.location.href = `${url}${accessToken ? `?access_token=${accessToken}&userName=${userName}` : ''}`;
  }

  render () {
    var self = this;
    return (
      <div className={styles.mainLayout}>
        <div className={styles.bg}></div>
        <div className={styles.headerClass}>
          <Header menus={this.state.menus}
                  setActiveModule={(activeModule) => this.changeField(
                    'activeModule', activeModule)}/>
        </div>
        <div className={styles.logoWrap}>
          {/*<img src=""/>*/}
        </div>
        <div className={styles.modulesContent}>
          <div className={styles.modulesItem}>
            {
              this.state.menus.map(function (line) {
                return  <a className={styles.modulesBtn} href='javascript:;' key={line.name} type='primary'
                           onClick={() => { self.goPages(line.entryUrl) }}>
                  {line.name}
                </a>
              })
            }
          </div>
        </div>

      </div>

    )
  }
}

export default connect()(Index)



/** WEBPACK FOOTER **
 ** ./src/components/homePage/Index.js
 **/